import { render } from "./TriggerButton.vue?vue&type=template&id=7a9c7c49"
import script from "./TriggerButton.vue?vue&type=script&lang=ts"
export * from "./TriggerButton.vue?vue&type=script&lang=ts"
script.render = render

export default script